import { render, staticRenderFns } from "./CostBasedConfiguration.vue?vue&type=template&id=41802439&scoped=true&"
import script from "./CostBasedConfiguration.vue?vue&type=script&lang=js&"
export * from "./CostBasedConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41802439",
  null
  
)

export default component.exports